// The pass/fail options and the keys that answer them, shared by Goods-in QC
// and the bench-test checklist.
//
// One definition so the on-button keycaps, the KeyHintBar and the keyboard
// handler cannot drift apart — the QC setup screen has always told operators
// "P to pass, F to fail, N for not applicable", and for a long time nothing
// implemented it.
const CHECK_OPTIONS = [
  { value: 'pass', label: 'Pass', key: 'P' },
  { value: 'fail', label: 'Fail', key: 'F' },
  { value: 'na', label: 'N/A', key: 'N' },
];

export default CHECK_OPTIONS;
